import type { ReactNode } from 'react';

export const PrintedPage: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  return <div style={{ pageBreakInside: 'avoid' }}>{children}</div>;
};
